<p-toast></p-toast>
<div class="invoicing-settings-container mt-6">
  <div class="flex justify-content-between mb-4 align-items-center">
    <p class="text-xl font-semibold">{{ 'layout.configurations.invoicingSettings.title' | translate:{ year: currentYear } }}</p>
    <p-button
      class="p-button-success"
      icon="pi pi-save"
      [label]="'layout.configurations.invoicingSettings.save' | translate"
      [disabled]="loading || !hasChanges || hasValidationErrors"
      (onClick)="save()"></p-button>
  </div>

  <div *ngIf="loading" class="mb-3 text-color-secondary">{{ 'layout.configurations.invoicingSettings.loading' | translate }}</div>

  <div class="invoicing-table-wrap">
  <p-table [value]="rows" responsiveLayout="scroll" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th class="month-col">{{ 'layout.configurations.invoicingSettings.month' | translate }}</th>
        <th class="number-col">{{ 'layout.configurations.invoicingSettings.forecastMonths' | translate }}</th>
        <th class="number-col">{{ 'layout.configurations.invoicingSettings.closingMonths' | translate }}</th>
        <th class="number-col">{{ 'layout.configurations.invoicingSettings.regenerateMonths' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="month-cell">{{ row.label }}</td>
        <td class="error-cell">
          <div class="field-with-popup">
            <p-inputNumber
              [(ngModel)]="row.forecastMonths"
              (ngModelChange)="onRowEdit(row)"
              [min]="1"
              [max]="12"
              [showButtons]="false"
              inputStyleClass="p-inputtext-sm"
              styleClass="invoicing-number">
            </p-inputNumber>
            <div class="error-popup" *ngIf="rowErrors[row.key]">
              {{ rowErrors[row.key] }}
            </div>
          </div>
        </td>
        <td>
          <p-inputNumber
            [(ngModel)]="row.closingMonths"
            [min]="1"
            [max]="12"
            [showButtons]="false"
            inputStyleClass="p-inputtext-sm"
            styleClass="invoicing-number">
          </p-inputNumber>
        </td>
        <td>
          <p-inputNumber
            [(ngModel)]="row.regenerateMonths"
            (ngModelChange)="onRowEdit(row)"
            [min]="1"
            [max]="12"
            [showButtons]="false"
            inputStyleClass="p-inputtext-sm"
            styleClass="invoicing-number">
          </p-inputNumber>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</div>
